export interface NavItem {
  name: string;
  href: string;
}

export interface MenuItem extends NavItem {
  hasSubmenu?: boolean;
}

export const navItems: NavItem[] = [
  { name: "Home", href: "/" },
  { name: "Games", href: "/games" },
  { name: "Services", href: "/services" },
];

export const menuItems: MenuItem[] = [
  { name: "Home", href: "/" },
  { name: "Games", href: "/games" },
  { name: "Services", href: "/services" },
  { name: "Gift Card Programs", href: "/gift-card-program" },
  { name: "Regulatory Resources", href: "/regulatory-resources" },
  { name: "The Complete Process", href: "/complete-process" },
  { name: "Income Calculator", href: "/income-calculator" },
  { name: "Contact Us", href: "/contact-us" },
];
